import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_COMMODITY_ORIGIN_PRODUCTION_PLACES_KEY } from '@/keys';
import type { ProductionPlace } from '@/types/core/production-declaration/production-place';

async function getProductionDeclarationCommodityOriginProductionPlaces(
  productionDeclarationId: string,
  materialId: string,
  commodityOriginId: string,
  options?: { token?: string },
): Promise<ProductionPlace[]> {
  const response = await api.get<ProductionPlace[]>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/production-places`,
    {
      params: options?.token ? { token: options.token } : undefined,
    },
  );

  return response.data;
}

export function useGetProductionDeclarationCommodityOriginProductionPlaces(
  productionDeclarationId: string,
  materialId: string,
  commodityOriginId: string,
  token: string | undefined,
): UseQueryResult<ProductionPlace[], Error> {
  return useQuery({
    queryKey: [
      ...GET_PRODUCTION_DECLARATION_COMMODITY_ORIGIN_PRODUCTION_PLACES_KEY,
      productionDeclarationId,
      materialId,
      commodityOriginId,
      token ?? '',
    ],
    queryFn: async () =>
      await getProductionDeclarationCommodityOriginProductionPlaces(
        productionDeclarationId,
        materialId,
        commodityOriginId,
        {
          token,
        },
      ),
    enabled: Boolean(
      productionDeclarationId && materialId && commodityOriginId,
    ),
  });
}
